const initContactValid = {
	firstName: { isErr: false, errMsg: '', canNotSave: true },
	lastName: { isErr: false, errMsg: '', canNotSave: true },
	companies: { isErr: false, errMsg: '', canNotSave: true },
	emailWork: { isErr: false, errMsg: '', canNotSave: false },
	emailPersonal: { isErr: false, errMsg: '', canNotSave: false },
	emailOther: { isErr: false, errMsg: '', canNotSave: false },
	contactPosition: { isErr: false, errMsg: '', canNotSave: false },
	// contactTypes: { isErr: false, errMsg: '', canNotSave: true },
	phoneWork: { isErr: false, errMsg: '', canNotSave: false },
	phoneMobile: { isErr: false, errMsg: '', canNotSave: false },
	phoneOther: { isErr: false, errMsg: '', canNotSave: false },
};

export default initContactValid;
